import React, { useState } from "react";
import { FaWhatsapp, FaEnvelope, FaTimes } from "react-icons/fa";
import CreateWhatsappCampaign from "./CreateWhatsappCampaign";

const CreateCampaignModal = ({ fetchCampaigns, onClose }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleClose = () => {
    setSelectedOption(null);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  // Render CreateWhatsappCampaign Component
  if (selectedOption === "whatsapp" || selectedOption === "email") {
    return (
      <CreateWhatsappCampaign
        fetchCampaigns={fetchCampaigns}
        onClose={handleClose}
        campaignType={selectedOption}
      />
    );
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-xl max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-4 rounded-t-lg">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                Create a Campaign
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Choose your campaign type to get started
              </p>
            </div>
            <button
              className="text-gray-500 hover:text-gray-700 p-2 hover:bg-gray-100 rounded-full transition-colors"
              onClick={handleClose}
              type="button"
            >
              <FaTimes className="text-lg" />
            </button>
          </div>
        </div>

        {/* Modal Content */}
        <div className="px-4 sm:px-6 py-6 sm:py-8">
          {/* Campaign Type Options */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {/* WhatsApp Option */}
            <div
              className="group flex flex-col items-center justify-center p-6 sm:p-8 bg-gradient-to-br from-green-50 to-green-100 rounded-xl shadow-sm hover:shadow-lg border-2 border-transparent hover:border-green-200 transition-all duration-300 cursor-pointer transform hover:scale-105"
              onClick={() => setSelectedOption("whatsapp")}
            >
              <div className="bg-white p-4 rounded-full shadow-md mb-4 group-hover:shadow-lg transition-shadow">
                <FaWhatsapp className="text-green-500 text-3xl sm:text-4xl" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                WhatsApp
              </h3>
              <p className="text-sm text-gray-600 text-center">
                Send messages directly to your contacts via WhatsApp
              </p>
              <div className="mt-4 px-4 py-2 bg-green-100 text-green-700 rounded-full text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Click to create
              </div>
            </div>

            {/* Email Option */}
            <div
              className="group flex flex-col items-center justify-center p-6 sm:p-8 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl shadow-sm hover:shadow-lg border-2 border-transparent hover:border-blue-200 transition-all duration-300 cursor-pointer transform hover:scale-105"
              onClick={() => setSelectedOption("email")}
            >
              <div className="bg-white p-4 rounded-full shadow-md mb-4 group-hover:shadow-lg transition-shadow">
                <FaEnvelope className="text-blue-500 text-3xl sm:text-4xl" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Email
              </h3>
              <p className="text-sm text-gray-600 text-center">
                Create and send professional email campaigns
              </p>
              <div className="mt-4 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Click to create
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-800 mb-2">
              Need help choosing?
            </h4>
            <div className="space-y-2 text-xs text-gray-600">
              <div className="flex items-start">
                <FaWhatsapp className="text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                <span>
                  WhatsApp campaigns are great for direct, personal
                  communication and have higher engagement rates
                </span>
              </div>
              <div className="flex items-start">
                <FaEnvelope className="text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
                <span>
                  Email campaigns are perfect for newsletters, promotions, and
                  detailed content sharing
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-4 sm:px-6 py-4 rounded-b-lg">
          <div className="flex justify-center">
            <button
              onClick={handleClose}
              className="px-6 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaignModal;
